import { Button } from '@tblabs/truffle';


export class SvgButton extends Button
{
    constructor(svg: string)
    {
        super(svg);

        this.Class("svg-button");
    }
}
